import { useState } from "react";
import { OrderDetails, TimeSeriesData } from "../shared/types/dashboard";
import { format } from "date-fns";

interface UseProductAnalysisReturn {
  selectedProduct: string | null;
  productSalesData: any[];
  handleProductSelect: (productName: string, recentOrders: OrderDetails[], timeSeries: TimeSeriesData[], timeRange: string) => void;
}

export const useProductAnalysis = (): UseProductAnalysisReturn => {
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null);
  const [productSalesData, setProductSalesData] = useState<any[]>([]);

  const handleProductSelect = (
    productName: string,
    recentOrders: OrderDetails[],
    timeSeries: TimeSeriesData[],
    timeRange: string
  ) => {
    setSelectedProduct(productName);

    const productOrders = recentOrders.filter((order) => 
      order.Products?.some((p: any) => p.ProductName === productName)
    );

    const productData = timeSeries.map((timePoint) => {
      const ordersInPeriod = productOrders.filter((order) => {
        const orderDate = new Date(order.Orderdate);

        if (timeRange === "today" || timeRange === "yesterday") {
          return orderDate.getHours() === parseInt(timePoint.date.split(":")[0]);
        } else if (timeRange === "week") {
          return format(orderDate, "EEE") === timePoint.date;
        } else {
          return format(orderDate, "MMM") === timePoint.date;
        }
      });

      const productSales = ordersInPeriod.reduce((sum, order) => {
        const product = order.Products?.find((p: any) => p.ProductName === productName);
        const amount = product?.amount ? (typeof product.amount === 'string' ? parseFloat(product.amount) : product.amount) : 0;
        const quantity = product?.quantity || 0;
        return sum + (amount * quantity);
      }, 0);

      return {
        date: timePoint.date,
        sales: productSales,
      };
    });

    setProductSalesData(productData);
  };

  return {
    selectedProduct,
    productSalesData,
    handleProductSelect,
  };
};